<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="padding-top: 1rem">
        <div style="font-size: 2rem;font-weight: bold;text-align: center">荣誉墙</div>
        <el-carousel :interval="4000" type="card" height="15rem">
          <el-carousel-item v-for="item in banner" style="width: 50%;text-align: center" :key="item.id">
            <el-image :src="item.fileUrl" style="height: 100%;width: 22rem"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="width: 90%;margin-left: 5%;">
          <div class="title">企业文化</div>
        <div style="display: flex">
          <div class="name">OUR HISTORY</div>
          <div style="width: 80%">
            <el-divider></el-divider>
          </div>
        </div>
      </div>
      <div style="min-height: 28rem">
        <div v-for="(item,index) in dataList" :key="item.id" :class="['data',item.isHovered ? 'hover-shadow':'']" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
          <div :class="item.title? 'date':'year' " :style="getStyle(index)">
            <div style="width: 100%" :style="{
              fontSize :item.isHovered ? '28px':'',
              color:item.isHovered ? '#1196db':''
            }">
              {{item.summary}}
            </div>
          </div>
          <div style="height: 100%;width: 2px;background-color: #707070"></div>
          <div style="width: 79%;height: 60px;  display: flex;align-items: center" class="font" @click="toDetails(item)">
            <div :style="{
              fontSize :item.isHovered ? '21px':'',
              color:item.isHovered ? '#1196db':''
            }" class="cul_details_title" v-bind:title="item.title">{{item.title}}</div>
            <div :style="{
              color:item.isHovered ? '#1196db':''
            }" class="details_date" v-if="item.title" >查看详情</div>
          </div>
        </div>
      </div>
      <div style="width: 100%;text-align: center">
        <el-pagination
            background
            style="text-align: center"
            layout="prev, pager, next"
            :total="total"
            :current-page="queryArticle.pageNum"
            :page-size="queryArticle.pageSize"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
        </div>
  </div>
</template>
<script>
import {getArticleList} from "@/api/article";
import {getBannerList} from "@/api/admin";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Culture',
  data() {
    return {
      banner:undefined,
      loading:false,
      date:undefined,
      dataList:[],
      total:undefined,
      queryArticle: {
        category:3,
        pageNum: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.initDataList()
    getBannerList({}).then(res=>{
      this.banner=res.data.content
    })
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  computed :{
    getStyle(){
      return function (index){
        const style='rightToLeft '+index*0.4+'s'
        return {'animation': style}
      }
    },
  },
  methods:{
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    handleCurrentChange(pageNum){
      this.queryArticle.pageNum=pageNum
      this.initDataList()
    },
    toDetails(item){
      item.isHovered=false
      this.$router.push({path:"/culture/details",query:{id:item.id}})
    },
    initDataList(){
      getArticleList(this.queryArticle).then(res=>{
        const data =res.data.content
        this.total=res.data.totalElements
        this.dataList=[]
        for (let i = 0; i <data.length ; i++) {
          data[i].isHovered=false
          if(data[i].summary.substring(0,4)!=this.date){
            this.date=data[i].summary.substring(0,4)
            this.dataList.push({summary:this.date})
            data[i].summary=data[i].summary.substring(5,10)
            this.dataList.push(data[i])
          }else if (data[i].summary.substring(0,4)==this.date){
            data[i].summary=data[i].summary.substring(5,10)
            this.dataList.push(data[i])
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.details_date{
  font-size: 0.6rem;
  width: 20%;cursor: pointer;
  text-align: center;
  cursor: pointer;
}
.cul_details_title{
  width: 70%;
  padding-left: 10%;
  font-size: 1rem;

}
.data{
  display: flex;
  height: 50px;
  width: 100%;
  font-weight: bold;

}
.font{
  font-size: 12px;
  font-weight:100;
  font-style: normal;
  font-family: 'Arial Normal', 'Arial', sans-serif;
}
.year{
  display: flex;
  align-items: center;
  height: 50px;
  width: 15%;
  text-align: left;
  justify-content: left;
    font-size: 1.5rem;
    color: #234C9C;
  margin-left: 2%;
    font-weight: bold;

}
.date{
  display: flex;
  align-items: center;
  height: 50px;
  width: 15%;
  text-align: right;
    font-size: 1.3rem;
    color: #1d1e1e;
    padding-right: 2%;
    font-weight: 300;
  /*animation: rightToLeft 3s;*/
}
.title {
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 20%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.home{
  padding-top: 4rem;
  width: 100%;
  background-color: #efefef;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}

</style>
<style >
@keyframes rightToLeft {
  0% {
    transform: translateX(50%);
    opacity: 0;
  }
  1% {
    transform: translateX(-100%);
  }
}
</style>
